import type { T_Maybe } from '@tryiris-ai/js-types';
import type { Notification } from '@studio/design-system/notification';

/** Status type for device settings */
export type StatusType = 'warning' | 'error';

/** Status with optional notification */
export type SettingsStatus = T_Maybe<StatusType>;

export const STATUS_NOTIFICATIONS: Record<StatusType, Notification> = {
  warning: {
    id: 'status-warning',
    message:
      'The camera is not responding to this command. Please validate you selected the correct driver, or submit a driver report for our team to investigate. ',
    title: 'Command warning',
    severity: 'warning',
    timestamp: new Date()
  },
  error: {
    id: 'status-error',
    message:
      'This command appears to be broken. Submit a driver error support by clicking button below.',
    title: 'Command Broken',
    severity: 'error',
    timestamp: new Date()
  }
};
